module.exports = ".download {\n  color: #176193;\n  font-weight: bold;\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/download-file-document/download-file-document.component.scss
// module id = ./src/app/shared/components/download-file-document/download-file-document.component.scss
// module chunks = main